// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3uhvd","loaderOuter":"PageOverlayLoader_loaderOuter__3PPED"};